import ReferralModel from './ReferralEntity';
import { states, select as stateFilter, translate as stateTranslate } from './ReferralStates';
import { referralColumns as columns, detailColumns } from './ReferralColumns';

export {
  states,
  stateFilter,
  stateTranslate,
  columns,
  detailColumns
}

export default ReferralModel;

export const headers = [
  { label: 'Id', field: 'id', size: 3 },
  { label: 'Nro. Envio', field: 'number', size: 3 },
  { label: 'Estado', field: 'state', size: 3 },
  { label: 'Creado', field: 'created', size: 3 },
  { label: 'Origen', field: 'warehouseOrigen', size: 3 },
  { label: 'Destino', field: 'warehouseDestination', size: 3 },
];